export default __webpack_public_path__ + "static/media/fragrance.2402b136.png";